var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOneoStorage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8.85939C0 8.24619 0 7.93959 0.0822526 7.65724C0.155113 7.40713 0.274851 7.17189 0.435586 6.96307C0.617041 6.72734 0.868912 6.53911 1.37266 6.16264L8.90855 0.530774C9.29891 0.239042 9.49409 0.0931758 9.70961 0.0371054C9.89978 -0.0123685 10.1002 -0.0123685 10.2904 0.0371054C10.5059 0.0931758 10.7011 0.239042 11.0915 0.530774L18.6273 6.16264C19.1311 6.53911 19.383 6.72734 19.5644 6.96307C19.7252 7.17189 19.8449 7.40713 19.9177 7.65724C20 7.93959 20 8.24619 20 8.85939V16.5836C20 17.7794 20 18.3774 19.7578 18.8341C19.5447 19.2359 19.2048 19.5626 18.7866 19.7673C18.3113 20 17.689 20 16.4444 20H3.55556C2.31099 20 1.68871 20 1.21335 19.7673C0.795217 19.5626 0.45526 19.2359 0.242208 18.8341C0 18.3774 0 17.7794 0 16.5836V8.85939Z",
    fill: "#DCEFE1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8436 14.9535H6.19365V9.96391H5.72925V7.26871H14.2708V9.96391H13.8436V14.9535ZM6.43365 14.7135H13.6024V9.72391H14.0296V7.50871H5.96925V9.72391H6.43365V14.7135Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.69751 9.71552V14.4495H13.3395V9.71552H6.69751ZM11.4699 11.4843H8.52991V10.7379H11.4699V11.4843Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.23315 7.77151V9.45992H6.65195H13.3852H13.7668V7.77151H6.23315Z",
    fill: "#091E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneoStorage);
export default __webpack_public_path__ + "static/media/OneoStorage.634c2ff8d4829c8eaf0d4784339845dc.svg";
export { ForwardRef as ReactComponent };